export default function cleanObject(obj, keysToRemove) {
  const cleanedObject = { ...obj };

  keysToRemove.forEach((key) => {
    delete cleanedObject[key];
  });

  return cleanedObject;
}

export function cleanArray(arr, keysToRemove, nestedKeys = {}) {
  return arr.map((item) => {
    const cleanedItem = { ...item };

    // حذف کلیدهای سطح اول
    keysToRemove.forEach((key) => {
      delete cleanedItem[key];
    });

    // پردازش کلیدهای تو در تو
    for (const [nestedKey, nestedKeysToRemove] of Object.entries(nestedKeys)) {
      if (Array.isArray(cleanedItem[nestedKey])) {
        cleanedItem[nestedKey] = cleanArray(
          cleanedItem[nestedKey],
          nestedKeysToRemove
        );
      }
    }

    return cleanedItem;
  });
}
